import React, { HTMLProps, LegacyRef, useRef, useState } from 'react';
import styled from 'styled-components';
import { ReactComponent as ClearText } from '@/assets/images/order/clearText.svg';

interface DNBoxInputProps
  extends Omit<HTMLProps<HTMLInputElement>, 'LegacyRef' | 'ref' | 'as'> {
  onClear?: () => void;
}

const DNBoxInput = (props: DNBoxInputProps) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [focused, setFocused] = useState<boolean>(false);

  const onClear = () => {
    if (!inputRef.current) {
      return;
    }
    inputRef.current.value = '';
    props.onClear?.();
  };

  return (
    <Wrapper>
      <Input
        ref={inputRef}
        focused={focused}
        onFocus={e => {
          setFocused(true);
          props.onFocus?.(e);
        }}
        onBlur={e => {
          setFocused(false);
          props.onBlur?.(e);
        }}
        {...props}
      />
      {props.onClear && props.value && (
        <ClearButton>
          <ClearText onClick={onClear} />
        </ClearButton>
      )}
    </Wrapper>
  );
};
export default DNBoxInput;

const Wrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

const Input = styled.input<{ focused: boolean }>`
  padding: 16px;
  border-radius: 12px;
  background-color: ${({ theme, focused }) =>
    focused ? theme.DF_COLOR.GRAY40 : theme.DF_COLOR.GRAY10};
  border: 1px solid
    ${({ theme, focused }) =>
      focused ? theme.DF_COLOR.GRAY300 : theme.DF_COLOR.GRAY50};
  color: ${({ theme }) => theme.DF_COLOR.GRAY900};
  ${({ theme }) => theme.DF_TYPOGRAPHY.UI18R};
`;

const ClearButton = styled.div`
  cursor: pointer;
  position: absolute;
  right: 0;
  padding: 10px 16px;
  display: flex;
`;
